import nBossConnection from 'modules/base/service/nBossConnection';
import { useTheme } from '@material-ui/core/styles';
import FuseLoading from '@fuse/core/FuseLoading';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { useDeepCompareEffect } from '@fuse/hooks';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import { Typography, Icon } from '@material-ui/core';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useParams, withRouter, Prompt, useHistory } from 'react-router-dom';
import _ from '@lodash';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import EdaService from '../service/EdaService';

function EdaViewPage(props) {
	const dispatch = useDispatch();
	const theme = useTheme();
	const history = useHistory();
	const routeParams = useParams();
	const { t } = useTranslation('editform');
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState(null);

	useDeepCompareEffect(() => {
		if (routeParams.id) {
			setLoading(true);
			EdaService.getData(routeParams.id).then(resp => {
				if (resp) {
					setLoading(false);
					setData(resp);
				} else {
					dispatch(showMessage({ message: 'Data not found' }));
					history.push('/eda');
				}
			});
		}
	}, [routeParams]);

	return (
		<FusePageCarded
			classes={{
				toolbar: 'p-0',
				header: 'min-h-72 h-72 sm:h-136 sm:min-h-136'
			}}
			header={
				<div className="flex flex-1 w-full items-center justify-between">
					<div className="flex flex-col items-start max-w-full min-w-0">
						<motion.div initial={{ x: 20, opacity: 0 }} animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}>
							<Typography className="flex items-center sm:mb-12" component={Button} role="button" onClick={() => history.goBack(history)} color="inherit">
								<Icon className="text-20">{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}</Icon>
								<span className="hidden sm:flex mx-4 font-medium">{t('BACK')}</span>
							</Typography>
						</motion.div>

						<div className="flex items-center max-w-full">
							<div className="flex flex-col min-w-0 mx-8 sm:mc-16">
								<motion.div initial={{ x: -20 }} animate={{ x: 0, transition: { delay: 0.3 } }}>
									<Typography className="text-16 sm:text-20 truncate font-semibold">EDA: {data ? data.getAsString('measurementListText') : ''}</Typography>
									<Typography variant="caption" className="font-medium">
										Types: {data ? data.getAsString('edaTypeListText') : ''}
									</Typography>
								</motion.div>
							</div>
						</div>
					</div>
					<motion.div className="flex" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0, transition: { delay: 0.3 } }}>
						<Button
							className="whitespace-nowrap mx-4 link"
							variant="contained"
							color="secondary"
							component="a"
							href={data && data.file !== null ? `${nBossConnection.baseUrl}fileRepository/getFile?key=${data.file}` : null}
							startIcon={<Icon className="hidden sm:flex">download</Icon>}
						>
							Download ZIP
						</Button>
					</motion.div>
				</div>
			}
			content={
				<div className="p-16 sm:p-24">
					{loading ? <FuseLoading /> : null}
					{!loading && data
						? data.itemList
								.filter(d => d.file !== null)
								.map(item => (
									<div>
										<h2 className="whitespace-nowrap mt-24 mb-16">
											{item.sensorType.modelId} : {item.edaType.name}
										</h2>
										<div className="flex items-center pt-8 pb-32">
											<img className="w-full h-auto" src={`${nBossConnection.baseUrl}fileRepository/getFile?key=${item.file}`} alt={`${item.sensorType.modelId} : ${item.edaType.name}`} />
										</div>
									</div>
								))
						: null}
				</div>
			}
		/>
	);
}

export default withRouter(EdaViewPage);
